import {
  gqlMutate,
  gqlQuery,
  mutationMockHandler,
} from '@hapana/shared/web/services/requests.service'
import { CORE_SET_USER_DATA_RESPONSE, CORE_USERS_MOCKED_RESPONSE } from '_mocks/user-access.mock'

import { coreUsersQuery } from './graphql/core-users.queries.js'
import * as mutations from './graphql/core-user.mutations.js'

const CORE_USERS = 'CORE_USERS'

export const getCoreUsers = gqlQuery({
  key: CORE_USERS,
  query: coreUsersQuery,
  mockResponse: CORE_USERS_MOCKED_RESPONSE,
  options: {
    isV1: false,
  },
})

export const setCoreUserData = ({ coreUserId, data }) =>
  gqlMutate({
    mutation: mutations.setCoreUserDataMutation,
    variables: {
      coreUserId,
      data: {
        defaultKpiOutputProperties: data,
      },
    },
    options: {
      isV1: false,
    },
  })

setCoreUserData.mockHandler = mutationMockHandler(mutations.setCoreUserDataMutation, {
  setCoreUserData: CORE_SET_USER_DATA_RESPONSE,
})
